import React from 'react';
import { ContentSection, Heading, Layout } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { Contracts } from 'components/contracts';
import { Greeting } from 'components/greeting';
import { DashboardMarketingCard } from 'components/dashboard-marketing-card/DashboardMarketingCard';

export const DashboardPage: React.FC = () => {
    const { t } = useTranslation('dashboard');
    const title = t('headline');

    return (
        <ContentSection pageWrapSize="medium">
            <Layout>
                <Layout.Item className={'u-mb'}>
                    <Heading level={1}>{title}</Heading>
                    <Greeting />
                </Layout.Item>
            </Layout>
            <Layout>
                <Layout.Item default={'2/3'} m={'1/1'}>
                    <Contracts />
                </Layout.Item>
                <Layout.Item default={'1/3'} m={'1/1'}>
                    <DashboardMarketingCard />
                </Layout.Item>
            </Layout>
        </ContentSection>
    );
};
